import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { Address } from 'src/app/domain/Address';
import { AddressService, UpdatedAutoCompleteAddressResponse } from 'src/app/services/address.service';
import { CountryService } from 'src/app/services/country.service';
import { FloatLabelModule } from "primeng/floatlabel";
import { DividerModule } from "primeng/divider";
import { requiredTrimmed } from '../address.component';
import { catchError, forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-CustomerAddresessUpdateModal',
  standalone: true,
  imports: [CommonModule, ButtonModule, ReactiveFormsModule, FormsModule, AutoCompleteModule, DropdownModule, InputTextModule, TranslateModule, FloatLabelModule, FloatLabelModule, DividerModule],
  templateUrl: './CustomerAddresessUpdateModal.component.html',
  styleUrls: ['./CustomerAddresessUpdateModal.component.scss']
})
export class CustomerAddresessUpdateModalComponent implements OnInit {

  newAddressForm = new FormGroup({
    id: new FormControl(),
    street: new FormControl(null, [requiredTrimmed, Validators.required]),
    zipCode: new FormControl(null, [requiredTrimmed, Validators.required]),
    city: new FormControl(null, [requiredTrimmed, Validators.required]),
    countryCode: new FormControl("", Validators.required),
    longitude: new FormControl(0),
    latitude: new FormControl(0),
    validatedBy: new FormControl(),
    street2: new FormControl()
  });
  countries: any[];
  selectedCountry: any;
  foundAddresses: any;
  customerId: "";

  constructor(private countryService: CountryService, private addressService: AddressService, public ref: DynamicDialogRef, public config: DynamicDialogConfig) {

  }

  ngOnInit() {
    // this.fetchCountries();

    if (this.config.data) {
      this.MapAddreseFormForModal();
    }
  }
  // fetchCountries() {
  //   this.countries = this.countryService.getClientCountries();
  // }

  onClearAddress() {
    this.newAddressForm.reset();
  }
  MapAddreseFormForModal() {
    let temp = (this.config.data.addressForm as FormGroup);
    this.newAddressForm.controls.city.setValue(temp.get('city')?.value ?? "");
    this.newAddressForm.controls.countryCode.setValue(temp.get('countryCode')?.value ?? "");
    this.newAddressForm.controls.latitude.setValue(temp.get('latitude')?.value ?? 0.0);
    this.newAddressForm.controls.longitude.setValue(temp.get('longitude')?.value ?? 0.0);
    this.newAddressForm.controls.street.setValue(temp.get('street')?.value ?? "");
    this.newAddressForm.controls.street2.setValue(temp.get('street2')?.value ?? "");
    this.newAddressForm.controls.validatedBy.setValue(temp.get('validatedBy')?.value ?? "");
    this.newAddressForm.controls.zipCode.setValue(temp.get('zipCode')?.value ?? "");
    this.newAddressForm.controls.id.setValue(this.config.data.addressId);

    this.newAddressForm.controls.city.disable();
    this.newAddressForm.controls.zipCode.disable()
    this.newAddressForm.controls.countryCode.disable()

    this.customerId = this.config.data.custoemrId;

  }
  setAddress(event: any) {
    if (event.longitude == null)
      this.addressService.resolveKdsAddress(event.kdsId).subscribe(x => {
        this.newAddressForm.patchValue({
          street: event.street,
          zipCode: event.zipCode,
          city: event.city,
          countryCode: event.countryCode,
          longitude: x.longitude,
          latitude: x.latitude,
          validatedBy: event.validatedBy,
        });
      })
    else
      this.newAddressForm.patchValue({
        street: event.street,
        zipCode: event.zipCode,
        city: event.city,
        countryCode: event.countryCode,
        longitude: event.longitude,
        latitude: event.latitude,
        validatedBy: event.validatedBy,
      });
  }

  formattedStreetName(item: Address) {
    if (item && item.street) {
      return `${item.street}`;
    }
    if (item) {
      return `${item}`;
    }
    return '';
  }

  searchAddress_Old(event: any) {
    this.addressService.autoCompleteAddress(event.query).subscribe((addressResult: UpdatedAutoCompleteAddressResponse) => {
      if (addressResult && addressResult.items) {
        this.foundAddresses = addressResult.items;
      }
    });
  }
  searchAddress(event: any) {
    const search = event.query?.trim();

    forkJoin({
      api: this.addressService.autoCompleteAddress(search) // backend autocomplte
        .pipe(catchError(error => {
          console.error('Internal address autocomplete failed', error);
          return of({ items: [] } as any);
        })
        ),

      kds: this.addressService.KdsAutocomplete(search)
    })
      .subscribe({
        next: ({ api, kds }) => {
          let addresses = [...kds, ...(api?.items ?? [])];
          let prioritized = [...addresses.filter(x => x.validatedBy === 'MongoDB'), ...addresses.filter(x => x.validatedBy !== 'MongoDB')];
          let seen = new Set<string>();

          this.foundAddresses = prioritized.filter(address => {
            let key = [address.street, address.houseNumber, address.postalCode].map(x => String(x ?? '').trim().toLowerCase()).join('|');

            if (seen.has(key)) return false;

            seen.add(key);
            return true;
          });
        },

        error: error => {
          console.error('Address search failed', error);
          this.foundAddresses = [];
        }
      });
  }

  addAddress() {
    let temp = {
      city: this.newAddressForm.controls.city.value,
      countryCode: this.newAddressForm.controls.countryCode.value,
      latitude: this.newAddressForm.controls.latitude.value,
      longitude: this.newAddressForm.controls.longitude.value,
      street: this.newAddressForm.controls.street.value,
      Street2: this.newAddressForm.controls.street2.value,
      validatedBy: this.newAddressForm.controls.validatedBy.value,
      zipCode: this.newAddressForm.controls.zipCode.value,
      id: this.newAddressForm.controls.id.value,
    } as Address

    this.ref.close(temp);
  }
  clearAddress() {
    this.newAddressForm.controls.city.reset();
    this.newAddressForm.controls.countryCode.reset();
    this.newAddressForm.controls.latitude.reset()
    this.newAddressForm.controls.longitude.reset();
    this.newAddressForm.controls.street.reset();
    this.newAddressForm.controls.validatedBy.reset();
    this.newAddressForm.controls.zipCode.reset();
  }

  close() {
    let temp = {
      city: this.newAddressForm.controls.city.value,
      countryCode: this.newAddressForm.controls.countryCode.value,
      latitude: this.newAddressForm.controls.latitude.value,
      longitude: this.newAddressForm.controls.longitude.value,
      street: this.newAddressForm.controls.street.value,
      Street2: this.newAddressForm.controls.street2.value,
      validatedBy: this.newAddressForm.controls.validatedBy.value,
      zipCode: this.newAddressForm.controls.zipCode.value,
      id: this.newAddressForm.controls.id.value,
    } as Address
    this.ref.close(temp);
  }
}
